import { render, staticRenderFns } from "./EvaluationPanel.vue?vue&type=template&id=5935bfb3&scoped=true"
import script from "./EvaluationPanel.vue?vue&type=script&lang=js"
export * from "./EvaluationPanel.vue?vue&type=script&lang=js"
import style0 from "./EvaluationPanel.vue?vue&type=style&index=0&id=5935bfb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935bfb3",
  null
  
)

export default component.exports